@layer tbw-plugins {
  .tbw-filter-panel {
    position: fixed;
    background: var(--tbw-filter-panel-bg, var(--tbw-color-panel-bg, light-dark(#eeeeee, #222222)));
    color: var(--tbw-filter-panel-fg, var(--tbw-color-fg, light-dark(#222222, #eeeeee)));
    border: 1px solid var(--tbw-filter-panel-border, var(--tbw-color-border, light-dark(#d0d0d4, #454545)));
    border-radius: var(--tbw-filter-panel-radius, var(--tbw-border-radius, 0.25rem));
    box-shadow: 0 4px 16px
      var(--tbw-filter-panel-shadow, var(--tbw-color-shadow, light-dark(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.3))));
    padding: var(--tbw-panel-padding, var(--tbw-spacing-lg, 0.75rem));
    z-index: 10000;
    min-width: 200px;
    max-width: 280px;
    max-height: 350px;
    display: flex;
    flex-direction: column;
    font-family: var(--tbw-font-family, system-ui, sans-serif);
    font-size: var(--tbw-font-size, 0.8125rem);
    /* Transform origin at top for drawer effect (panel below header) */
    transform-origin: top center;
  }

  /* When panel is positioned above header, animate from bottom */
  .tbw-filter-panel.tbw-filter-panel-above {
    transform-origin: bottom center;
  }

  /* Panel enter animation - controlled by class added via JS */
  .tbw-filter-panel.tbw-filter-panel-animated {
    animation: tbw-filter-panel-enter var(--tbw-animation-duration, 150ms) var(--tbw-animation-easing, ease-out);
  }

  /* When above header, use upward animation */
  .tbw-filter-panel.tbw-filter-panel-above.tbw-filter-panel-animated {
    animation: tbw-filter-panel-enter-above var(--tbw-animation-duration, 150ms) var(--tbw-animation-easing, ease-out);
  }

  /* Drawer-like animation: scales down vertically + fades, like opening from header */
  @keyframes tbw-filter-panel-enter {
    from {
      opacity: 0;
      transform: scaleY(0.3) translateY(-10px);
    }
    to {
      opacity: 1;
      transform: scaleY(1) translateY(0);
    }
  }

  /* Upward animation for when panel is above header */
  @keyframes tbw-filter-panel-enter-above {
    from {
      opacity: 0;
      transform: scaleY(0.3) translateY(10px);
    }
    to {
      opacity: 1;
      transform: scaleY(1) translateY(0);
    }
  }

  /* CSS Anchor Positioning - modern browsers */
  @supports (anchor-name: --test) {
    .tbw-filter-panel {
      position-anchor: --tbw-filter-anchor;
      /* Position below header row, right-aligned to the filter button */
      top: anchor(bottom);
      right: anchor(right);
      /* Explicitly reset the inset sides we do not use. Required because the
         browser UA stylesheet for [popover] sets `inset: 0; margin: auto`,
         leaving left: 0 and margin-inline: auto active unless we override them
         here. Without these resets the panel is incorrectly stretched/centered
         across the viewport when shown as a popover (used for top-layer
         isolation so anchor positioning works inside CDK dialogs). */
      left: auto;
      bottom: auto;
      margin-inline: 0;
      margin-top: 4px;
      /* Fallback positions when overflowing viewport */
      position-try-fallbacks:
      /* Try aligning to left edge instead */
        flip-inline,
        /* Try flipping to above the anchor */ flip-block,
        /* Try both flips */ flip-block flip-inline;
    }
  }

  .tbw-filter-search {
    margin-bottom: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
    min-height: var(--tbw-filter-item-height, 28px);
  }

  .tbw-filter-search-input {
    height: var(--tbw-filter-item-height, 28px);
    width: 100%;
    padding: var(--tbw-filter-search-padding, var(--tbw-spacing-sm, 0.375rem) var(--tbw-spacing-md, 0.5rem));
    background: var(--tbw-filter-input-bg, var(--tbw-color-bg, transparent));
    color: inherit;
    border: 1px solid var(--tbw-filter-input-border, var(--tbw-color-border, light-dark(#d0d0d4, #454545)));
    border-radius: var(--tbw-filter-input-radius, var(--tbw-border-radius, 0.25rem));
    font-size: inherit;
    box-sizing: border-box;
  }

  .tbw-filter-search-input:focus {
    outline: none;
    border-color: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
    box-shadow: 0 0 0 2px rgba(from var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6)) r g b / 15%);
  }

  .tbw-filter-actions {
    display: flex;
    padding: var(--tbw-button-padding-sm, 0.25rem 0.125rem);
    margin-bottom: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
    border-bottom: 1px solid var(--tbw-filter-divider, var(--tbw-color-border, light-dark(#d0d0d4, #454545)));
    min-height: var(--tbw-filter-item-height, 28px);
  }
  .tbw-filter-actions .tbw-filter-value-item {
    flex: 1;
  }

  .tbw-filter-values {
    flex: 1;
    overflow-y: auto;
    margin-bottom: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
    max-height: 180px;
    position: relative;
  }

  .tbw-filter-values-spacer {
    width: 1px;
  }

  .tbw-filter-values-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .tbw-filter-value-item {
    display: flex;
    align-items: center;
    gap: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
    padding: var(--tbw-button-padding-sm, 0.25rem 0.125rem);
    cursor: pointer;
    border-radius: 3px;
    /* Item height for virtualization - used by JS for positioning calculations */
    height: var(--tbw-filter-item-height, 28px);
  }

  .tbw-filter-value-item:hover {
    background: var(--tbw-filter-hover, var(--tbw-color-row-hover, light-dark(#f0f6ff, #1c1c1c)));
  }

  .tbw-filter-checkbox {
    margin: 0;
    cursor: pointer;
    accent-color: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
  }

  .tbw-filter-no-match {
    color: var(--tbw-filter-muted, var(--tbw-color-fg-muted, light-dark(#555555, #aaaaaa)));
    padding: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem)) 0;
    text-align: center;
    font-style: italic;
  }

  .tbw-filter-buttons {
    display: flex;
    gap: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
    padding-top: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
    border-top: 1px solid var(--tbw-filter-divider, var(--tbw-color-border, light-dark(#d0d0d4, #454545)));
  }

  .tbw-filter-apply-btn {
    flex: 1;
    padding: var(--tbw-filter-btn-padding, var(--tbw-button-padding, 0.375rem 0.75rem));
    background: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
    color: var(--tbw-filter-accent-fg, var(--tbw-color-accent-fg, light-dark(#ffffff, #000000)));
    border: none;
    border-radius: var(--tbw-border-radius, 0.25rem);
    cursor: pointer;
    font-size: var(--tbw-font-size-sm, 0.8125rem);
    font-weight: var(--tbw-filter-btn-font-weight, 500);
    min-height: var(--tbw-filter-btn-min-height, auto);
  }

  .tbw-filter-apply-btn:hover {
    filter: brightness(0.9);
  }

  .tbw-filter-clear-btn {
    flex: 1;
    padding: var(--tbw-filter-btn-padding, var(--tbw-button-padding, 0.375rem 0.75rem));
    background: transparent;
    color: var(--tbw-filter-muted, var(--tbw-color-fg-muted, light-dark(#555555, #aaaaaa)));
    border: 1px solid var(--tbw-filter-input-border, var(--tbw-color-border, light-dark(#d0d0d4, #454545)));
    border-radius: var(--tbw-border-radius, 0.25rem);
    cursor: pointer;
    font-size: var(--tbw-font-size-sm, 0.8125rem);
    font-weight: var(--tbw-filter-btn-font-weight, 500);
    min-height: var(--tbw-filter-btn-min-height, auto);
  }

  .tbw-filter-clear-btn:hover {
    background: var(--tbw-filter-hover, var(--tbw-color-row-hover, light-dark(#f0f6ff, #1c1c1c)));
  }

  /* Range filter panel (number columns) */
  .tbw-filter-range-inputs,
  .tbw-filter-date-range {
    display: flex;
    align-items: flex-end;
    gap: var(--tbw-spacing-sm, 0.375rem);
    margin-bottom: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
  }

  .tbw-filter-range-group,
  .tbw-filter-date-group {
    display: flex;
    flex-direction: column;
    gap: var(--tbw-spacing-xs, 0.25rem);
    flex: 1;
  }

  .tbw-filter-range-label {
    font-size: var(--tbw-font-size-xs, 0.75rem);
    color: var(--tbw-filter-muted, var(--tbw-color-fg-muted, light-dark(#555555, #aaaaaa)));
  }

  .tbw-filter-range-input,
  .tbw-filter-date-input {
    width: 100%;
    height: var(--tbw-filter-item-height, 28px);
    padding: var(--tbw-spacing-xs, 0.25rem) var(--tbw-spacing-sm, 0.375rem);
    background: var(--tbw-filter-input-bg, var(--tbw-color-bg, transparent));
    color: inherit;
    border: 1px solid var(--tbw-filter-input-border, var(--tbw-color-border, light-dark(#d0d0d4, #454545)));
    border-radius: var(--tbw-filter-input-radius, var(--tbw-border-radius, 0.25rem));
    font-size: inherit;
    box-sizing: border-box;
  }

  .tbw-filter-range-input:focus,
  .tbw-filter-date-input:focus {
    outline: none;
    border-color: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
    box-shadow: 0 0 0 2px rgba(from var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6)) r g b / 15%);
  }

  .tbw-filter-range-separator {
    color: var(--tbw-filter-muted, var(--tbw-color-fg-muted, light-dark(#555555, #aaaaaa)));
    padding-bottom: var(--tbw-spacing-xs, 0.25rem);
  }

  /* Blank option checkbox */
  .tbw-filter-blank-option {
    display: flex;
    align-items: center;
    gap: var(--tbw-spacing-sm, 0.375rem);
    padding: var(--tbw-spacing-xs, 0.25rem) 0;
    margin-bottom: var(--tbw-spacing-xs, 0.25rem);
    font-size: var(--tbw-font-size-sm, 0.8125rem);
    cursor: pointer;
    user-select: none;
  }

  .tbw-filter-blank-checkbox {
    accent-color: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
    margin: 0;
    cursor: pointer;
  }

  /* Disabled state for date range / number range when blank is checked */
  .tbw-filter-date-range.tbw-filter-disabled,
  .tbw-filter-range-inputs.tbw-filter-disabled,
  .tbw-filter-range-slider.tbw-filter-disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  /* Dual-thumb range slider */
  .tbw-filter-range-slider {
    position: relative;
    height: 24px;
    margin: var(--tbw-spacing-md, 0.5rem) 0 var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
  }

  .tbw-filter-range-track {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--tbw-filter-input-border, var(--tbw-color-border, light-dark(#d0d0d4, #454545)));
    border-radius: 2px;
    transform: translateY(-50%);
  }

  .tbw-filter-range-fill {
    position: absolute;
    top: 50%;
    height: 4px;
    background: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
    border-radius: 2px;
    transform: translateY(-50%);
  }

  .tbw-filter-range-thumb {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: none;
    pointer-events: none;
    -webkit-appearance: none;
    appearance: none;
  }

  .tbw-filter-range-thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    background: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
    border: 2px solid var(--tbw-filter-panel-bg, var(--tbw-color-panel-bg, light-dark(#eeeeee, #222222)));
    border-radius: 50%;
    cursor: pointer;
    pointer-events: all;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .tbw-filter-range-thumb::-moz-range-thumb {
    width: 16px;
    height: 16px;
    background: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
    border: 2px solid var(--tbw-filter-panel-bg, var(--tbw-color-panel-bg, light-dark(#eeeeee, #222222)));
    border-radius: 50%;
    cursor: pointer;
    pointer-events: all;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .tbw-filter-range-thumb::-webkit-slider-thumb:hover {
    transform: scale(1.1);
  }

  .tbw-filter-range-thumb::-moz-range-thumb:hover {
    transform: scale(1.1);
  }
} /* End @layer tbw-plugins */
